export default {
  loading: false,
  exportLoading: false,
  tableData: {},
  chartData: {},
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-analytic/features/reports/pages/delivered-provider-beta/store/states.js